import React, { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "hi" : "en")), []);
  // t picks localized string from { en, hi } object; passes through plain strings
  const t = useCallback(
    (obj) => {
      if (obj == null) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] ?? obj.en ?? "";
    },
    [lang]
  );
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
